import AddOnSubscriptionCard from "./AddOnSubscriptionCard";
import {
  BRANDED_APP_STRIPE_PRICE_IDS,
  GROW_STRIPE_PRICE_IDS,
  STRIPE_PRICE_IDS,
  TRAIN_STRIPE_PRICE_IDS,
} from "../constants/subscriptionIds";
import { CustomerStripeSubscriptionSummary } from "../../../apis/billingApi";

interface AddOnSubscriptionsProps {
  subscriptionSummaries?: CustomerStripeSubscriptionSummary[];
}

const AddOnSubscriptions = ({
  subscriptionSummaries = [],
}: AddOnSubscriptionsProps) => {
  const addOnsToShow = [];

  const hasGrowSubscription = subscriptionSummaries.some((subscription) =>
    GROW_STRIPE_PRICE_IDS.includes(subscription.priceId),
  );

  const hasTrainSubscription = subscriptionSummaries.some((subscription) =>
    TRAIN_STRIPE_PRICE_IDS.includes(subscription.priceId),
  );

  const hasBrandedAppSubscription = subscriptionSummaries.some((subscription) =>
    BRANDED_APP_STRIPE_PRICE_IDS.includes(subscription.priceId),
  );

  if (!hasGrowSubscription) {
    addOnsToShow.push(STRIPE_PRICE_IDS.growMonthly_4_1_24);
  }
  if (!hasTrainSubscription) {
    addOnsToShow.push(STRIPE_PRICE_IDS.trainTierOne);
  }
  if (!hasBrandedAppSubscription) {
    addOnsToShow.push(STRIPE_PRICE_IDS.brandedApp);
  }

  if (addOnsToShow.length === 0) {
    return null;
  }

  return (
    <div>
      <h2 className="tw-text-lg tw-font-bold tw-text-neutral-700 tw-mb-6">
        Add-Ons
      </h2>
      <div className="tw-flex tw-flex-wrap tw-gap-4">
        {addOnsToShow.map((addOnPriceId) => {
          return (
            <AddOnSubscriptionCard key={addOnPriceId} priceId={addOnPriceId} />
          );
        })}
      </div>
    </div>
  );
};

export default AddOnSubscriptions;
